// Self-hosted fonts via Fontsource (bundled by Vite - NO Google Fonts CDN beacon).
import "@fontsource/frank-ruhl-libre/400.css";
import "@fontsource/frank-ruhl-libre/500.css";
import "@fontsource/frank-ruhl-libre/700.css";
import "@fontsource/inter-tight/400.css";
import "@fontsource/inter-tight/500.css";
import "@fontsource/inter-tight/600.css";
import "@fontsource/inter-tight/700.css";

import "./styles/tokens.css";
import "./styles/app.css";
import { mountApp } from "./app.ts";
import { registerServiceWorker } from "./lib/swUpdate.ts";
import { initInstallCapture } from "./lib/pwaInstall.ts";

// Intercept the one-shot beforeinstallprompt early (before any view mounts) so the
// Tools-menu "Install app" button can fire it on demand instead of the browser's
// mini-infobar. No-op on iOS (the event never fires there).
initInstallCapture();

const root = document.getElementById("app");
if (root) mountApp(root);

// No-backend PWA = no server logs. A single top-level seam so an unhandled
// rejection can't slip away unnoticed (and a place to wire telemetry later). It
// does NOT preventDefault, so real errors still reach the console for debugging.
window.addEventListener("unhandledrejection", (e) => {
  if (import.meta.env.DEV) console.warn("[unhandledrejection]", e.reason);
});

// PWA: register the service worker in production only (avoids dev HMR interference),
// with a user-gated update flow (swUpdate.ts) so a deploy never breaks an open tab.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => registerServiceWorker());
}

